<template>
  <div class="insurance-split-detail-manage">
    <el-card>
      <div class="filter-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="95px">
          <el-form-item label="分账记录ID" prop="splitOrderId">
            <el-input v-model="queryParams.splitOrderId" placeholder="请输入分账记录ID" clearable style="width: 220px;" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="接收方类型" prop="receiverType">
            <el-select v-model="queryParams.receiverType" placeholder="请选择" clearable style="width: 140px;">
              <el-option v-for="item in receiverTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收方账号" prop="receiverAccount">
            <el-input v-model="queryParams.receiverAccount" placeholder="请输入接收方账号" clearable style="width: 200px;" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="接收方名称" prop="receiverName">
            <el-input v-model="queryParams.receiverName" placeholder="请输入接收方名称" clearable style="width: 180px;" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="分账状态" prop="splitStatus">
            <el-select v-model="queryParams.splitStatus" placeholder="请选择" clearable style="width: 140px;">
              <el-option v-for="item in splitStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="dateRange" style="width: 240px" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="loading" :data="detailList" border stripe>
        <el-table-column type="index" width="60" align="center" />
        <el-table-column label="分账记录ID" prop="splitOrderId" width="220" show-overflow-tooltip />
        <el-table-column label="接收方类型" prop="receiverType" width="110" align="center">
          <template slot-scope="scope">
            <el-tag size="small">{{ getReceiverTypeText(scope.row.receiverType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接收方账号" prop="receiverAccount" min-width="180" show-overflow-tooltip />
        <el-table-column label="接收方名称" prop="receiverName" min-width="140" show-overflow-tooltip />
        <el-table-column label="分账金额" prop="splitAmount" width="110" align="center">
          <template slot-scope="scope">{{ formatAmount(scope.row.splitAmount) }}</template>
        </el-table-column>
        <el-table-column label="分账状态" prop="splitStatus" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getSplitStatusType(scope.row.splitStatus)" size="small">{{ getSplitStatusText(scope.row.splitStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="渠道明细号" prop="channelDetailNo" min-width="160" show-overflow-tooltip />
        <el-table-column label="失败原因" prop="failReason" min-width="160" show-overflow-tooltip />
        <el-table-column label="创建时间" prop="createTime" width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.page" :page-sizes="[10, 20, 30, 50]" :page-size="queryParams.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </el-card>

    <el-dialog title="保险分账明细详情" :visible.sync="detailOpen" width="750px" append-to-body>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="明细ID">{{ detailForm.id }}</el-descriptions-item>
        <el-descriptions-item label="分账记录ID">{{ detailForm.splitOrderId }}</el-descriptions-item>
        <el-descriptions-item label="接收方类型">{{ getReceiverTypeText(detailForm.receiverType) }}</el-descriptions-item>
        <el-descriptions-item label="接收方账号">{{ detailForm.receiverAccount }}</el-descriptions-item>
        <el-descriptions-item label="接收方名称">{{ detailForm.receiverName }}</el-descriptions-item>
        <el-descriptions-item label="分账金额">{{ formatAmount(detailForm.splitAmount) }}</el-descriptions-item>
        <el-descriptions-item label="分账状态">{{ getSplitStatusText(detailForm.splitStatus) }}</el-descriptions-item>
        <el-descriptions-item label="渠道明细号">{{ detailForm.channelDetailNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="失败原因" :span="2">{{ detailForm.failReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detailForm.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatTime(detailForm.updateTime) }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'InsuranceSplitDetailManage',
  data() {
    return {
      loading: false,
      total: 0,
      detailList: [],
      detailOpen: false,
      detailForm: {},
      dateRange: [],
      queryParams: {
        page: 1,
        limit: 10,
        splitOrderId: null,
        receiverType: null,
        receiverAccount: null,
        receiverName: null,
        splitStatus: null
      },
      receiverTypeOptions: [
        { label: '保险公司', value: 1 },
        { label: '商户', value: 2 },
        { label: '平台', value: 3 }
      ],
      splitStatusOptions: [
        { label: '待分账', value: 0 },
        { label: '分账成功', value: 1 },
        { label: '分账失败', value: 2 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const { data: res } = await this.$http.post('/insurance/split/order/detail/page', this.addDateRange(this.queryParams, this.dateRange))
        if (res.code !== 200) return this.$message.error(res.msg || '获取数据失败')
        this.detailList = res.data.list || []
        this.total = res.data.total || 0
      } finally {
        this.loading = false
      }
    },
    handleDetail(row) {
      this.detailForm = { ...row }
      this.detailOpen = true
    },
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    resetQuery() {
      this.dateRange = []
      this.$refs.queryForm && this.$refs.queryForm.resetFields()
      this.handleQuery()
    },
    handleSizeChange(val) {
      this.queryParams.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    addDateRange(params, dateRange) {
      const search = { ...params, beginTime: '', endTime: '' }
      if (dateRange && dateRange.length === 2) {
        search.beginTime = dateRange[0]
        search.endTime = dateRange[1]
      }
      return search
    },
    formatAmount(value) {
      const num = parseFloat(value)
      return isNaN(num) ? '-' : '¥' + num.toFixed(2)
    },
    formatTime(time) {
      if (!time) return '-'
      return String(time).replace('T', ' ')
    },
    getReceiverTypeText(value) {
      const item = this.receiverTypeOptions.find(item => item.value === value)
      return item ? item.label : '-'
    },
    getSplitStatusText(value) {
      const item = this.splitStatusOptions.find(item => item.value === value)
      return item ? item.label : '-'
    },
    getSplitStatusType(value) {
      return value === 1 ? 'success' : value === 2 ? 'danger' : 'info'
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}
</style>
